// extracted by mini-css-extract-plugin
module.exports = {"LandingFooter":"landing-footer_LandingFooter__KYDuT","entry":"landing-footer_entry__rpBvD typography_bodyFont__Sn75r","entryLink":"landing-footer_entryLink__HrMhx"};